<template>
  <div>
    <div
      class="flight-details-with-layover"
      v-for="(segment, segmentIndex) in journey.legs"
      :key="segment.flightNumber"
    >
      <div class="flight-details">
        <div class="journey-details-container">
          <!-- date, airline #, codeshare -->
          <div class="is-flex is-align-items-baseline mb-4">
            <div class="is-flex">
              <b-icon
                icon="calendar"
                class="has-text-grey-light"
                size="is-small"
              ></b-icon>
              <span class="ml-1 has-text-grey-light is-size-7">
                {{ segment.departingAt.date | formatDate }}
              </span>
            </div>
            <div class="ml-4 is-size-7">
              <img
                width="16"
                :src="
                  $helpers.airlineLogo(segment.marketingAirline.code, 16, 16)
                "
              />
              <span class="has-text-grey-light">
                {{ segment.marketingAirline.code }} #{{ segment.flightNumber }}
              </span>
            </div>
            <div
              v-if="segment.codeshareInfo"
              class="ml-1 is-size-7 has-text-grey-light"
            >
              -
              {{ segment.codeshareInfo | operatedBy }}
            </div>
          </div>
          <!-- flight details -->
          <div class="columns is-multiline is-gapless mb-1 has-text-grey">
            <div class="column mr-6">
              <div class="columns is-mobile is-gapless mb-1">
                <div class="column is-narrow">

                  <AirportDetails :airportCode="segment.departingAirport" />


                  <div class="is-size-7 has-text-grey">
                    {{ getAirportLocation(segment.departingAirport) }}
                  </div>

                  <div class="has-text-grey is-size-6">
                    {{ segment.departingAt.time | formatTime }}
                  </div>
                </div>
                <div class="column is-narrow mx-3">
                  <span class="is-size-7 mt-2 is-block">
                    <b-icon
                      icon="arrow-right"
                      class="has-text-grey-light"
                    ></b-icon>
                  </span>
                </div>
                <div class="column is-narrow">
                
                  <AirportDetails :airportCode="segment.arrivingAirport" />

                  <div class="is-size-7 has-text-grey">
                    {{ getAirportLocation(segment.arrivingAirport) }}
                  </div>
                  <div class="has-text-grey is-size-6">
                    {{ segment.arrivingAt.time | formatTime }}

                    <span
                      class="is-size-7 ml-1 has-text-danger"
                      v-if="segment.arrivingAt.date != segment.departingAt.date"
                    >
                      {{ segment.arrivingAt.date | formatDate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Flight Tags -->
            <div class="column mr-1">
              <div class="ml-0 has-text-grey is-size-7">
                <div class="tag is-block mb-1 pt-1">
                  <span>
                    Booking Class:
                  </span>
                  <span class="detail-value">
                    {{ segment.fareInfo.bookingClass }}
                  </span>
                </div>
                <div class="tag is-block mb-1 pt-1">
                  <span>
                    Cabin:
                  </span>
                  <span class="detail-value">
                    {{ segment.fareInfo.cabinName }}
                  </span>
                </div>
                <div v-if="segment.selectedSeat" class="tag is-block mb-1 pt-1">
                  <span>
                    Selected Seat:
                  </span>
                  <span class="detail-value">
                    {{ segment.selectedSeat.id }}
                  </span>
                </div>
                <div v-else class="tag is-block is-full mb-1 pt-1">
                  <span>
                    Available Seats:
                  </span>
                  <span class="detail-value">
                    {{ availableSeats(segment.fareInfo.availableSeats) }}
                  </span>
                </div>
              </div>
            </div>
            <!-- On-Time Performance -->
            <div class="column">
              <FlightOTPRatingBadge
                :journeyIndex="journeyIndex"
                :airline-code="segment.marketingAirline.code"
                :flight-number="segment.flightNumber"
                :departure-airport="segment.departingAirport"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="layover-container p-3 pl-4 is-size-7 has-text-grey"
        v-if="
          journey.layovers.length > 0 && segmentIndex < journey.layovers.length
        "
      >
        <div class="columns is-mobile">
          <div class="column is-narrow is-italic">
            Layover in
            {{ getAirportLocation(journey.layovers[segmentIndex].airport) }}
          </div>
          <div class="column is-narrow">
            <span
              v-bind:class="
                getLayoverClass(
                  journey.layovers[segmentIndex].durationInMinutes
                )
              "
            >
              {{
                journey.layovers[segmentIndex].durationInMinutes
                  | formatDuration
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FlightOTPRatingBadge from "./FlightOTPRatingBadge";
import AirportDetails from './AirportDetails.vue';


export default {
  name: "FlightDetailsInfo",
  props: {
    journey: Object,
    journeyIndex: Number,
    uniqueId: Number,
  },
  components: {
    FlightOTPRatingBadge,
    AirportDetails, 

  },
  data: function() {
    return {
      showOTPPerformanceFlightNumber: "",
      showOTPPerformanceDepartureAirport: "",
      otpError: false,
      showOTP: false,
      currentIndex: "",
      previousIndex: "",
      multiline: true,
    };
  },
  computed: {},
  methods: {
    filterByFlight(val0, val1, val2) {
      var val = { journey: val0, segment: val1, flightNum: val2 };
      this.$emit("filter", val);
    },
    availableSeats(num) {
      if (num == "9") {
        return "9+";
      }
      return num;
    },
 
    getAirportLocation(airportCode) {
      let airport = this.$globals.airports.find(
        (airportItem) => airportItem.code === airportCode
      );
   

      if (!airport) return null;

      if (airport.state) return airport.city + ", " + airport.state;
      else return airport.city + ", " + airport.country;
    },
    getLayoverClass(durationInMinutes) {
      if (durationInMinutes > 180 || durationInMinutes < 45) {
        return "has-text-danger";
      }

      return "";
    },
    showOTPPerformance(index, departureAirport, currentIndex) {
      this.currentIndex = "";

      if (!index || index === "") {
        this.otpError = true;
        return;
      }

      if (this.previousIndex !== "" && this.previousIndex === currentIndex) {
        this.showOTP = false;
        this.previousIndex = "";
      } else {
        this.showOTP = true;
        this.currentIndex = currentIndex;
        this.previousIndex = currentIndex;
        this.showOTPPerformanceFlightNumber = index;
        this.showOTPPerformanceDepartureAirport = departureAirport;
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.bar {
  list-style: none;
}

.bar > li {
  position: relative;
}

.bar > li:before {
  content: "\25CF";
  font-size: 20px;
  content: "\25CF";
  position: absolute;
  padding: 8px;
}

.bar > li:after {
  position: absolute;
  left: 0;
  top: 0;
  content: "";
  border-left: 2px solid #4a4a4a;
  height: 57%;
  margin-left: 0.8rem;
  margin-top: 0.9rem;
}

.bar > li:first-of-type:after {
  top: 31%;
}

.bar > li:last-of-type:after {
  top: -50%;
}

.barMargin {
  margin-left: 1.25rem;
}

.sect {
  background-color: white;
  margin: 10px;
  border-radius: 5px;
}

.g_sect {
  margin: 10px;
  border-radius: 5px;
  text-align: left;
  padding-bottom: 0px;
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
}

.add_margins {
  margin: 10px;
}

.nopad-margins {
  padding-top: 0px;
  margin: 0px;
}

.wdt {
  width: 55%;
  margin: auto;
}

.nobtmpd {
  margin: 0px;
}

.vl {
  /* border-left: 6px solid #E4E8E8; */
  height: 15px;
  margin-bottom: 5px;
}

.flight-details {
  position: relative;
  border-left: 3px dotted #eee;
  padding-left: 20px;
}

.layover-container {
  //border-top: 1px dashed #ddd;
  //border-bottom: 1px dashed #ddd;
  //border-right: 1px dashed #ddd;
  position: relative;
  border-left: 3px solid white;
  //border: 1px dashed #ddd;
  //border-radius: 10px;
}

/*.flight-details:before,  {
  position: absolute;
  width: 20px;
  height: 20px;
  left: -12px;
  top: 20px;
  content: "";
  background: lightgrey;
  border-radius: 50%;
}*/

.layover-container:before {
  position: absolute;
  width: 20px;
  height: 20px;
  left: -12px;
  content: "";
  // background: #eee;
  border-radius: 50%;
  border: 4px solid #ddd;
}

.time-column {
  max-width: 100px;
}

/*.journey-details-container:not(:first-of-type) {
  border-left: 6px solid #eee;
}*/
.detail-value {
  display: inline;
  font-weight: bold;
}
</style>
